module.exports = __webpack_public_path__ + "static/media/register_left.c4b66b5d.png";